/**
 * @module ol/source/common
 */

/**
 * Default WMS version.
 * @type {string}
 */
export var DEFAULT_WMS_VERSION = '1.3.0';

//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/source/common.js
// module id = 271
// module chunks = 0